import React, { useState } from "react";
import SelectInput from "../../components/reuse/formComponets/SelectInput";
import TextInput from "../../components/reuse/formComponets/TextInput";
import RadioInput from "../../components/reuse/formComponets/RadioInput";
import CheckboxGroup from "../../components/reuse/formComponets/CheckboxGroup";

function Forms() {
  const [mainImage, setMainImage] = useState(null);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Vehicles");
  const [selectedSubCategory, setSelectedSubCategory] = useState();

  const handleCategoryChange = (event) =>
    setSelectedCategory(event.target.value);

  const handleSubCategoryChange = (event) =>
    setSelectedSubCategory(event.target.value);

  const handleMainImageChange = (event) => {
    const file = event.target.files[0];
    if (file) setMainImage(URL.createObjectURL(file));
  };

  const handleAdditionalImagesChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + additionalImages.length <= 5) {
      const imageUrls = files.map((file) => URL.createObjectURL(file));
      setAdditionalImages((prev) => [...prev, ...imageUrls]);
    } else {
      alert("You can upload a maximum of 5 images.");
    }
  };

  const removeImage = (index) =>
    setAdditionalImages((prev) => prev.filter((_, i) => i !== index));

  return (
    <div className="flex justify-center items-start bg-gray-100 py-10 min-h-screen">
      <div className="lg:w-[85%] lg:max-w-[60%] bg-white shadow-md rounded-lg p-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6 text-center">
          Fill the Details Below
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column: Common Fields */}
          <div className="space-y-6">
            <SelectInput
              label="Category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              options={[
                "Vehicles",
                "Properties",
                "Jobs",
                "Electronics",
                "Education",
                "Pets",
                "Home & Garden",
                "Services",
                "Fashion & Beauty",
                "Hobby & Entertainment",
                "Agriculture",
                "Essentials",
                "Others",
              ]}
            />

            {/* Subcategory appears immediately after Category */}
            {selectedCategory === "Vehicles" && (
              <SelectInput
                label="Sub Category (Vehicles)"
                options={[
                  "Select your Sub Category",
                  "Cars",
                  "Vans",
                  "Bus",
                  "Motor Cycle",
                  "Lorries",
                  "Three Wheeler",
                  "Machinery",
                  "Commercial Vehicles",
                  "Tractors",
                  "Rent-A-Car",
                  "Motor Accessory",
                  "Others",
                ]}
              />
            )}

            {selectedCategory === "Properties" && (
              <SelectInput
                label="Sub Category (Properties)"
                options={[
                  "Select your Sub Category",
                  "House",
                  "Lands",
                  "Apartments",
                  "Board & Lodge",
                ]}
              />
            )}

            {selectedCategory === "Jobs" && (
              <SelectInput
                label="Sub Category (Jobs)"
                options={[
                  "Job Vacancy",
                  "Job Wanted",
                  "Job Services",
                  "Other Job",
                ]}
              />
            )}

            {selectedCategory === "Electronics" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Select Sub Category",
                  "Laptop",
                  "Mobile Phones",
                  "Mobile Phone Accessories",
                  "Computure and Tablets",
                  "Computer Accessories",
                  "Video Games and Consoles",
                  "TV and Video Accessories",
                  "Camera and Camcorders ",
                  "Audio and Music Equipment",
                  "Air Conditions & Electrical Fittings",
                  "Electronic & Home Appliances",
                  "Other electronics",
                ]}
              />
            )}

            {selectedCategory === "Education" && (
              <SelectInput
                value={selectedSubCategory}
                onChange={handleSubCategoryChange}
                label="Sub Category"
                options={[
                  "Grade 1-2",
                  "Grade 3-5",
                  "Grade 6-9",
                  "Grade 10-11",
                  "Grade 12-13",
                  "London O/L - A/L",
                  "Higher Education",
                  "Language Classes",
                  "IELTS , TOEFL",
                  "GRE",
                  "PTE",
                  "ICT Education",
                  "Assinment Assisting Services",
                  "Web Development & Multimedia",
                  "Vocational Training",
                  "Naita",
                  "Other Education",
                ]}
              />
            )}
            {selectedCategory === "Pets" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Birds",
                  "Cats",
                  "Dogs",
                  "Rabbits",
                  "Fish",
                  "Other Pets",
                  "Pet Foods",
                  "Pet Accessories",
                  "Veterinary Services",
                ]}
              />
            )}
            {selectedCategory === "Home & Garden" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Furniture",
                  "Bathroom & Sanitary ware",
                  "Building Materials & Tools",
                  "Garden",
                  "Home Decoration",
                  "Kitchen Items",
                  "Other Home & Garden",
                ]}
              />
            )}
            {selectedCategory === "Services" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Trade Service",
                  "Domestic Service",
                  "Events & Entertainment",
                  "Health & Wellbeing",
                  "Travel & Tourism",
                  "Other Services",
                  "Beauty Products",
                  "Other Personal Items",
                ]}
              />
            )}
            {selectedCategory === "Fashion & Beauty" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Bags & Luggages",
                  "Clothing",
                  "Shoes & Footwear",
                  "Jewellery",
                  "Sunglasses & Opticians",
                  "Watches",
                  "Other Fashion Accessories",
                  "Sports & Fitness",
                  "Other Beauty Products",
                ]}
              />
            )}
            {selectedCategory === "Hobby & Entertainment" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Musical Instruments",
                  "Sports Supplies",
                  "Travel , Events & Tickets",
                  "Art & Collectibes",
                  "Music, Books & Movies",
                  "Children's Items",
                  "Other Hobby , Sport & kids Items",
                ]}
              />
            )}
            {selectedCategory === "Agriculture" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Crops , Seeds & Plants",
                  "Other Agriculture",
                  "Farming Tools & Machineries",
                ]}
              />
            )}
            {selectedCategory === "Essentials" && (
              <SelectInput
                label="Sub Category"
                options={[
                  "Grocery",
                  "Fruits & Vegetables",
                  "Meat & Seafood",
                  "Baby Products",
                  "Healthcare Products",
                  "Household",
                  "Gas",
                  "Other Essentials",
                ]}
              />
            )}
            {selectedCategory === "Others" && (
              <TextInput
                label="Sub Category"
                placeholder="Enter your Sub Category"
              />
            )}

            <TextInput label="Title" placeholder="Enter your Title" />
            <TextInput label="Price" placeholder="Enter your Price" />
            <RadioInput label="Negotiable" options={["Yes", "No"]} />

            {/* Image Upload Section */}
            <div className="flex flex-col gap-2">
              <label className="text-gray-600 font-medium">Main Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleMainImageChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              {mainImage && (
                <img
                  src={mainImage}
                  alt="Main"
                  className="mt-2 w-20 h-20 object-contain"
                />
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-gray-600 font-medium">
                Add Images (Up to 5)
              </label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleAdditionalImagesChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
              <div className="flex gap-2 mt-2 flex-wrap">
                {additionalImages.map((image, index) => (
                  <div key={index} className="relative">
                    <img
                      src={image}
                      alt={`Additional ${index + 1}`}
                      className="w-20 h-20 object-contain rounded-md"
                    />
                    <button
                      onClick={() => removeImage(index)}
                      className="absolute top-0 right-0 text-white bg-red-500 rounded-full w-6 h-6 flex items-center justify-center"
                    >
                      &times;
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <TextInput label="Name" placeholder="Enter your Name" />
            <TextInput label="E-mail" placeholder="example@gmail.com" />
            <TextInput label="Phone" placeholder="Personal Phone number" />
          </div>

          {/* Right Column: Category-Specific Fields */}
          <div className="space-y-6">
            {selectedCategory === "Vehicles" && (
              <>
                <SelectInput
                  label="Brand"
                  options={["Select Vehicle Brand", "Toyota", "Honda", "Ford"]}
                />
                <SelectInput
                  label="Model"
                  options={["-Select-", "Model A", "Model B"]}
                />
                <SelectInput
                  label="Model Year"
                  options={["-Select-", "2022", "2023", "2024"]}
                />
                <SelectInput
                  label="Engine Capacity"
                  options={["-Select-", "1000cc", "1500cc"]}
                />
                <RadioInput
                  label="Condition"
                  options={["Registered", "Unregistered"]}
                />
                <RadioInput
                  label="Transmission"
                  options={["Automatic", "Manual"]}
                />
                <RadioInput
                  label="Fuel Type"
                  options={["Petrol", "Diesel", "Hybrid", "Electric"]}
                />
                <TextInput label="Mileage" placeholder="Enter mileage" />
              </>
            )}

            {selectedCategory === "Properties" && (
              <>
                <SelectInput
                  label="Bedrooms"
                  options={[
                    "Select How many Bedrooms",
                    "1 Bedroom",
                    "2 Bedrooms",
                    "3 Bedrooms",
                    "4 Bedrooms",
                    "5 Bedrooms",
                    "6 Bedrooms",
                    "7 Bedrooms",
                    "8 Bedrooms",
                    "9 Bedrooms",
                    "10+ Bedrooms",
                  ]}
                />
                <SelectInput
                  label="Bathrooms"
                  options={[
                    "Select How many Bathrooms",
                    "1 Bathroom",
                    "2 Bathrooms",
                    "3 Bathrooms",
                    "4 Bathrooms",
                    "5+ Bathrooms",
                  ]}
                />
                <TextInput
                  label="Floor Area (SQFT)"
                  placeholder="Enter Floor Area"
                />
                <TextInput
                  label="Land Size (Perches)"
                  type="number"
                  placeholder="Enter Land Size"
                />
              </>
            )}
            {selectedCategory === "Electronics" && (
              <>
                <SelectInput
                  label="Brand"
                  options={[
                    "Select Electronic Brand",
                    "Apple",
                    "Samsung",
                    "Sony",
                    "Huawei",
                    "Xiaomi",
                    "Motorola",
                    "Nokia",
                    "LG",
                    "Apple",
                    "Samsung",
                    "Sony",
                    "Huawei",
                    "Xiaomi",
                    "Motorola",
                    "Nokia",
                    "LG",
                  ]}
                />
                <TextInput label="Model" placeholder="Enter Electronic Model" />
                <TextInput label="Year" placeholder="Enter Electronic Year" />
              </>
            )}
            {selectedSubCategory === "Grade 1-2" && (
              <>
                <SelectInput
                  label="Course"
                  options={[
                    "-Select-",
                    "Hindu",
                    "Buddhism",
                    "Catholic",
                    "Islam",
                    "Sinhala Language & Literature",
                    "English",
                    "Mathematics",
                    "Science",
                  ]}
                />
                <SelectInput
                  label="Medium"
                  options={["-Select-", "English", "Sinhala", "Tamil", "Other"]}
                />
              </>
            )}
            {selectedCategory === "Pets" && (
              <TextInput
                type="number"
                label="Pet Age"
                placeholder="Enter Pet Age"
              />
            )}

            <TextInput label="Phone 1" placeholder="07XXXXXXXX" />
            <TextInput label="OTP" placeholder="Enter OTP" />
            <TextInput label="Phone 2" placeholder="07XXXXXXXX" />
            <TextInput label="OTP" placeholder="Enter OTP" />
          </div>
        </div>
        <TextInput
          label="Description"
          placeholder="Enter Bout your Ad"
          className="w-full px-4 h-40  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400  focus:border-transparent transition-all placeholder-gray-400 mb-4
                "
        />
        {selectedCategory === "Vehicles" && (
          <CheckboxGroup
            label="Features of Vehicle"
            options={[
              "A/C: FRONT",
              "POWER MIRRORS",
              "CRUISE CONTROL",
              "LANE DEPARTURE ALERT",
              "SUNROOF/MOONROOF",
              "A/C: REAR",
              "CENTRAL LOCKS",
              "NAVIGATION SYSTEM",
              "ABS",
              "THIRD ROW SEATS",
              "POWER STEERING",
              "ALLOY WHEELS",
            ]}
          />
        )}
        {selectedCategory === "Properties" && (
          <CheckboxGroup
            label="Features of House"
            options={[
              "Dining",
              "Servant Quarters",
              "Wet Kitchen",
              "Balcony",
              "Guest Bathrooms",
              "Kitchen",
              "Verandah",
              "Pantry",
              "CCTV",
              "Car Park",
              "Swimming Pool",
              "Dining",
              "Servant Quarters",
              "Wet Kitchen",
              "Balcony",
              "Guest Bathrooms",
              "Kitchen",
              "Verandah",
              "Pantry",
              "CCTV",
              "Car Park",
              "Swimming Pool",
            ]}
          />
        )}

        <button className="w-full bg-primary hover:bg-primary/90 text-white py-3 rounded-lg mt-8 transition-all">
          Publish Your Advertisement
        </button>
      </div>
    </div>
  );
}

export default Forms;
